import { useState } from "react";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, ExternalLink, Info } from "lucide-react";

const BC_URL = "https://old.beacukai.go.id/websitenewV2/cek-imei.html";

export default function CekImei() {
  const [imei, setImei] = useState("");
  const openBC = () => window.open(BC_URL, "_blank", "noopener");
  return (
    <div>
      <PageHeader title="Cek IMEI Bea Cukai" subtitle="Pastikan IMEI HP terdaftar & legal sebelum jual/beli" />
      <div className="max-w-2xl space-y-4">
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
          <div className="flex items-center gap-2 mb-3 text-sky-700"><ShieldCheck className="w-5 h-5" /><h3 className="font-medium">Masukkan Nomor IMEI</h3></div>
          <Label className="text-xs text-slate-500">Nomor IMEI (dial *#06# di HP untuk melihat)</Label>
          <Input value={imei} onChange={(e) => setImei(e.target.value)} placeholder="Contoh: 356789101112131" className="mt-1 font-mono-num" data-testid="cekimei-input" />
          <Button onClick={openBC} className="mt-3 bg-sky-600 hover:bg-sky-700" data-testid="cekimei-btn">
            <ExternalLink className="w-4 h-4 mr-1.5" /> Cek di Web Bea Cukai
          </Button>
          <p className="text-xs text-slate-400 mt-2">Tombol akan membuka situs resmi Bea Cukai di tab baru. Salin nomor IMEI di atas lalu tempel pada kolom pengecekan di situs tersebut.</p>
        </div>

        <div className="bg-sky-50 rounded-xl border border-sky-100 p-6">
          <div className="flex items-center gap-2 mb-3 text-sky-700"><Info className="w-5 h-5" /><h3 className="font-medium">Cara Membaca Hasil Cek IMEI</h3></div>
          <ul className="space-y-2 text-sm text-slate-600 list-disc pl-5">
            <li><span className="font-medium text-green-700">"IMEI terdaftar / terverifikasi"</span> — HP legal & aman digunakan dengan jaringan seluler Indonesia.</li>
            <li><span className="font-medium text-red-700">"IMEI tidak terdaftar"</span> — HP kemungkinan ilegal/BM (Black Market); sinyal bisa diblokir. Hati-hati membeli.</li>
            <li>Untuk HP bawaan dari luar negeri, IMEI harus didaftarkan lewat Bea Cukai (bagasi penumpang) agar bisa dipakai.</li>
            <li>Selalu cek IMEI unit bekas/second sebelum transaksi untuk menghindari HP yang diblokir.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
